import { render, staticRenderFns } from "./Serp.vue?vue&type=template&id=51294106&scoped=true&"
import script from "./Serp.vue?vue&type=script&lang=js&"
export * from "./Serp.vue?vue&type=script&lang=js&"
import style0 from "./Serp.vue?vue&type=style&index=0&id=51294106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51294106",
  null
  
)

export default component.exports